package com.trevorwiebe.timesheet.di

import com.trevorwiebe.timesheet.core.data.createHttpClient
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.externals.connectFirestoreEmulator
import dev.gitlive.firebase.firestore.externals.initializeFirestore
import dev.gitlive.firebase.functions.externals.connectFunctionsEmulator
import dev.gitlive.firebase.functions.externals.getFunctions
import dev.gitlive.firebase.storage.externals.connectStorageEmulator
import dev.gitlive.firebase.storage.externals.getStorage
import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import org.koin.dsl.module

@JsModule("firebase/app")
@JsNonModule
private external object FirebaseAppJs {
    fun getApp(): dynamic
}

// Force long-polling on production web: the default WebChannel transport intermittently stalls
// get() on some networks (a 15s "Request timed out" with no response). Must run before any
// Firestore access.
fun configureWebFirestore() {
    val settings: dynamic = js("({ experimentalForceLongPolling: true })")
    initializeFirestore(FirebaseAppJs.getApp(), settings)
}

actual fun createEmulatorConfig(): FirebaseEmulatorConfig = JsFirebaseEmulatorConfig()

class JsFirebaseEmulatorConfig : FirebaseEmulatorConfig {
    override fun setupEmulators(firebase: Firebase) {
        firebase.auth.useEmulator("localhost", 9099)
        // Force long-polling: the Firestore emulator's gRPC-Web transport doesn't support
        // WebSocket, so the SDK would wait ~30 seconds before falling back without this.
        val settings: dynamic = js("({ experimentalForceLongPolling: true })")
        val jsFirestore = initializeFirestore(FirebaseAppJs.getApp(), settings)
        connectFirestoreEmulator(jsFirestore, "localhost", 8080)
        val jsFunctions = getFunctions()
        connectFunctionsEmulator(jsFunctions, "localhost", 5001)
        val jsStorage = getStorage()
        connectStorageEmulator(jsStorage, "localhost", 9199.0)
    }
}

val jsFirebaseOptions = FirebaseOptions(
    applicationId = "1:146957704760:web:b48153b4dad6199ebe90cd",
    apiKey = "AIzaSyDkTAdwr5Bwz5UztonhnGsCKJ0e3E2c3hs",
    projectId = "timesheet-3b40b",
    storageBucket = "timesheet-3b40b.firebasestorage.app",
    gcmSenderId = "146957704760",
    authDomain = "timesheet-3b40b.firebaseapp.com"
)

// Firebase is initialized eagerly in main() before startKoin — lazy Koin single
// blocks can't guarantee ordering when firebase.auth/firestore is used in sharedModule.
actual val platformModule = module { }

// Web Firestore runs without persistent cache, so there is nothing to wipe.
actual fun clearFirestoreCache(firebase: Firebase) { }

actual fun httpClient(): HttpClient {
    return createHttpClient(Js.create())
}
